import { render, staticRenderFns } from "./SignUp.auth.vue?vue&type=template&id=16bc1e74&scoped=true&"
import script from "./SignUp.auth.vue?vue&type=script&lang=js&"
export * from "./SignUp.auth.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.auth.vue?vue&type=style&index=0&id=16bc1e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc1e74",
  null
  
)

export default component.exports